import { Action } from "redux";
import { Language, ThunkAction } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = [
  "GET_LANGUAGES_SUCCESS",
  "GET_LANGUAGES_ERROR",
] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type GetLanguagesSuccess = ActionBase<"GET_LANGUAGES_SUCCESS"> & {
  languages: Language[];
};
type GetLanguagesError = ActionBase<"GET_LANGUAGES_ERROR"> & { error: Error };

export type LanguagesAction = GetLanguagesSuccess | GetLanguagesError;

export const isLanguagesAction = (action: Action): action is LanguagesAction =>
  isActionType(action, ActionTypeKeys);

export const getLanguages = (): ThunkAction<Promise<LanguagesAction>> => {
  return (dispatch) => {
    return fetch({ dispatch, authorize: false })
      .get("languages")
      .then((res) => dispatch(getLanguagesSuccess(res.data.languages)))
      .catch((error) => {
        dispatch(getLanguagesError(error));
        throw error;
      });
  };
};

const getLanguagesSuccess = (languages: Language[]): GetLanguagesSuccess => ({
  type: "GET_LANGUAGES_SUCCESS",
  languages,
});

const getLanguagesError = (error: Error): GetLanguagesError => ({
  type: "GET_LANGUAGES_ERROR",
  error,
});
